import { render, staticRenderFns } from "./TabsContainerBar.vue?vue&type=template&id=1ec819e6&"
import script from "./TabsContainerBar.vue?vue&type=script&lang=js&"
export * from "./TabsContainerBar.vue?vue&type=script&lang=js&"
import style0 from "./TabsContainerBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports